// ===== Husn-e-Naaz theme JS — uses Shopify's native AJAX Cart API =====

function formatMoney(cents) {
  return (window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : 'Rs. {{amount}}')
    .replace('{{amount}}', (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 0 }));
}

function showToast(msg) {
  const toast = document.querySelector('.js-toast');
  if (!toast) return;
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(window._toastTimer);
  window._toastTimer = setTimeout(() => toast.classList.remove('show'), 2400);
}

function openCart() {
  document.querySelector('.cart-drawer:not(.wishlist-drawer)')?.classList.add('open');
  document.getElementById('CartScrim')?.classList.add('show');
}
function closeCart() {
  document.querySelector('.cart-drawer:not(.wishlist-drawer)')?.classList.remove('open');
  document.getElementById('CartScrim')?.classList.remove('show');
}

/* ===== Wishlist (localStorage) ===== */
const WISHLIST_KEY = 'hn_wishlist';

function getWishlist() {
  try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
}
function saveWishlist(items) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
}
function isWishlisted(id) {
  return getWishlist().some(i => String(i.id) === String(id));
}
function toggleWishlist(data) {
  let items = getWishlist();
  if (isWishlisted(data.id)) {
    items = items.filter(i => String(i.id) !== String(data.id));
  } else {
    items.push(data);
  }
  saveWishlist(items);
  updateWishlistUI();
}
function updateWishlistUI() {
  const items = getWishlist();
  document.querySelectorAll('.js-wishlist-count').forEach(el => {
    el.textContent = items.length;
    el.style.display = items.length > 0 ? 'inline-flex' : 'none';
  });
  document.querySelectorAll('.js-wishlist-toggle').forEach(btn => {
    const active = isWishlisted(btn.dataset.id);
    btn.classList.toggle('active', active);
    btn.setAttribute('aria-pressed', String(active));
  });
  renderWishlistDrawer();
}
function renderWishlistDrawer() {
  const itemsEl = document.querySelector('.js-wishlist-items');
  if (!itemsEl) return;
  const items = getWishlist();
  if (items.length === 0) {
    itemsEl.innerHTML = `<div class="cart-empty">Your wishlist is empty.<br><br><a href="/collections/all" class="btn btn-outline">Discover Products</a></div>`;
    return;
  }
  itemsEl.innerHTML = items.map(item => `
    <div class="cart-line" data-wishlist-id="${item.id}">
      <a href="${item.url}"><img src="${item.image}" alt="${item.title}"></a>
      <div class="cart-line__info">
        <a href="${item.url}"><h4>${item.title}</h4></a>
        <p>${item.price}</p>
        <button class="cart-line__remove js-wishlist-remove" data-id="${item.id}">Remove</button>
      </div>
    </div>
  `).join('');
}
function openWishlist() {
  document.getElementById('WishlistDrawer')?.classList.add('open');
  document.getElementById('WishlistScrim')?.classList.add('show');
}
function closeWishlist() {
  document.getElementById('WishlistDrawer')?.classList.remove('open');
  document.getElementById('WishlistScrim')?.classList.remove('show');
}

/* ===== Recently viewed (localStorage) ===== */
const RECENTLY_VIEWED_KEY = 'hn_recently_viewed';

function trackRecentlyViewed(product) {
  let items = [];
  try { items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || []; } catch (e) { items = []; }
  items = items.filter(i => String(i.id) !== String(product.id));
  items.unshift(product);
  items = items.slice(0, 8);
  localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items));
}

function renderRecentlyViewed(excludeId) {
  const section = document.querySelector('.js-recently-viewed');
  const strip = document.querySelector('.js-rv-strip');
  if (!section || !strip) return;
  let items = [];
  try { items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || []; } catch (e) { items = []; }
  if (excludeId) items = items.filter(i => String(i.id) !== String(excludeId));
  if (items.length === 0) { section.style.display = 'none'; return; }
  section.style.display = '';
  strip.innerHTML = items.map(item => `
    <a class="rv-card" href="${item.url}">
      <div class="rv-card__img"><img src="${item.image}" alt="${item.title}" loading="lazy"></div>
      <h4>${item.title}</h4>
      <span>${item.price}</span>
    </a>
  `).join('');
}

/* ===== Predictive search ===== */
let searchDebounce;
async function runSearch(term) {
  const resultsEl = document.querySelector('.js-search-results');
  if (!resultsEl) return;
  if (!term || term.length < 2) { resultsEl.innerHTML = ''; return; }
  try {
    const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor`);
    const data = await res.json();
    const products = data.resources?.results?.products || [];
    if (products.length === 0) {
      resultsEl.innerHTML = `<p class="search-empty">No products found for "${term}".</p>`;
      return;
    }
    resultsEl.innerHTML = products.map(p => `
      <a class="search-result" href="${p.url}">
        <img src="${p.featured_image?.url || ''}" alt="${p.title}">
        <div class="search-result__info">
          <h4>${p.title}</h4>
          <span>${p.price}</span>
        </div>
      </a>
    `).join('');
  } catch (e) { /* ignore */ }
}
function openSearch() {
  document.getElementById('SearchOverlay')?.classList.add('open');
  setTimeout(() => document.getElementById('SearchInput')?.focus(), 50);
}
function closeSearch() {
  document.getElementById('SearchOverlay')?.classList.remove('open');
}

/* ===== Size guide ===== */
function openSizeGuide() {
  document.querySelector('.js-size-guide-overlay')?.classList.add('open');
}
function closeSizeGuide() {
  document.querySelector('.js-size-guide-overlay')?.classList.remove('open');
}

/* ===== Collection filter panel (mobile) ===== */
function openFilterPanel() {
  document.querySelector('.js-filter-panel')?.classList.add('open');
  document.getElementById('FilterScrim')?.classList.add('show');
}
function closeFilterPanel() {
  document.querySelector('.js-filter-panel')?.classList.remove('open');
  document.getElementById('FilterScrim')?.classList.remove('show');
}

async function refreshCartDrawer() {
  const res = await fetch('/cart?view=drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
  if (res.ok) {
    const html = await res.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector('.cart-drawer');
    const current = document.querySelector('.cart-drawer');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();
  document.querySelectorAll('.js-cart-count').forEach(el => el.textContent = cart.item_count);
}

async function buyNow(id, quantity, button) {
  if (button) { button.disabled = true; button.textContent = 'Processing…'; }
  try {
    const res = await fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity }] })
    });
    const data = await res.json();
    if (!res.ok) {
      showToast(data.description || 'Could not start checkout');
      if (button) { button.disabled = false; button.textContent = 'Checkout Now'; }
      return;
    }
    window.location.href = '/checkout';
  } catch (e) {
    showToast('Something went wrong — please try again');
    if (button) { button.disabled = false; button.textContent = 'Checkout Now'; }
  }
}

async function addToCart(id, quantity) {
  try {
    const res = await fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity }] })
    });
    const data = await res.json();
    if (!res.ok) {
      showToast(data.description || 'Could not add to bag');
      return;
    }
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    document.querySelectorAll('.js-cart-count').forEach(el => el.textContent = cart.item_count);
    renderDrawerFromCart(cart);
    openCart();
    showToast(`${data.product_title || 'Item'} added to bag`);
  } catch (e) {
    showToast('Something went wrong — please try again');
  }
}

function renderDrawerFromCart(cart) {
  const itemsEl = document.querySelector('.js-cart-items');
  const footEl = document.querySelector('.js-cart-foot');
  if (!itemsEl) return;
  if (cart.item_count === 0) {
    itemsEl.innerHTML = `<div class="cart-empty">Your bag is empty.<br><br><a href="/collections/all" class="btn btn-outline">Continue Shopping</a></div>`;
    if (footEl) footEl.style.display = 'none';
    return;
  }
  if (footEl) footEl.style.display = 'block';
  itemsEl.innerHTML = cart.items.map((item, i) => `
    <div class="cart-line" data-line="${i + 1}">
      <img src="${item.image}" alt="${item.product_title}">
      <div class="cart-line__info">
        <h4>${item.product_title}</h4>
        <p>${item.variant_title || ''} &nbsp;·&nbsp; Qty: ${item.quantity}</p>
        <p>${formatMoney(item.final_line_price)}</p>
        <button class="cart-line__remove js-cart-remove" data-line="${i + 1}">Remove</button>
      </div>
    </div>
  `).join('');
  const totalEl = document.querySelector('.js-cart-total');
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
}

async function removeLine(line) {
  const res = await fetch(window.theme.routes.cartChange, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ line, quantity: 0 })
  });
  const cart = await res.json();
  document.querySelectorAll('.js-cart-count').forEach(el => el.textContent = cart.item_count);
  renderDrawerFromCart(cart);
}

document.addEventListener('DOMContentLoaded', () => {
  // Header glass effect on scroll
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Scroll-reveal animations
  if ('IntersectionObserver' in window) {
    const revealTargets = document.querySelectorAll('.section-head, .story, .trust__grid, .newsletter, .stats-grid');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealTargets.forEach(el => revealObserver.observe(el));
  } else {
    document.querySelectorAll('.section-head, .story, .trust__grid, .newsletter, .stats-grid').forEach(el => el.classList.add('is-visible'));
  }

  // Subtle 3D tilt on product cards (desktop hover only)
  if (window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.product-card__img').forEach(img => {
      img.addEventListener('mousemove', (e) => {
        const rect = img.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        img.style.transform = `rotateY(${x * 8}deg) rotateX(${y * -8}deg)`;
      });
      img.addEventListener('mouseleave', () => { img.style.transform = ''; });
    });
  }

  // Hero parallax
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const heroImgs = document.querySelectorAll('.hero img');
  if (heroImgs.length && !reduceMotion) {
    let ticking = false;
    const updateParallax = () => {
      const offset = Math.max(-50, Math.min(50, window.scrollY * 0.25));
      heroImgs.forEach(img => { img.style.transform = `scale(1.15) translateY(${offset}px)`; });
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(updateParallax); ticking = true; }
    }, { passive: true });
    updateParallax();
  }

  // Magnetic hover effect on primary buttons (desktop only)
  if (window.matchMedia('(hover: hover)').matches && !reduceMotion) {
    document.querySelectorAll('.btn-gold, .hero .btn').forEach(btn => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = (e.clientX - rect.left - rect.width / 2) * 0.25;
        const y = (e.clientY - rect.top - rect.height / 2) * 0.25;
        btn.style.transform = `translate(${x}px, ${y}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  // Staggered reveal for lookbook tiles
  if ('IntersectionObserver' in window) {
    const tileObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          tileObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    document.querySelectorAll('.lookbook-grid > a').forEach((tile, i) => {
      tile.style.transitionDelay = `${(i % 6) * 80}ms`;
      tileObserver.observe(tile);
    });
  }

  // Animated count-up stats
  if ('IntersectionObserver' in window) {
    const countObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseFloat(el.dataset.countTo || '0');
        const decimals = el.dataset.countTo && el.dataset.countTo.includes('.') ? 1 : 0;
        const duration = 1400;
        const start = performance.now();
        const step = (now) => {
          const progress = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target.toFixed(decimals);
        };
        requestAnimationFrame(step);
        countObserver.unobserve(el);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.js-count-up').forEach(el => countObserver.observe(el));
  }

  document.querySelector('.js-burger')?.addEventListener('click', (e) => {
    const expanded = e.currentTarget.getAttribute('aria-expanded') === 'true';
    e.currentTarget.setAttribute('aria-expanded', String(!expanded));
    document.querySelector('.mobile-menu')?.classList.toggle('open');
  });
  document.querySelector('.js-cart-open')?.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  });
  document.querySelector('.js-cart-close')?.addEventListener('click', closeCart);
  document.getElementById('CartScrim')?.addEventListener('click', closeCart);

  document.querySelector('.js-cart-items')?.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-cart-remove');
    if (btn) removeLine(btn.dataset.line);
  });

  // Recently viewed
  if (window.__currentProduct) {
    trackRecentlyViewed(window.__currentProduct);
    renderRecentlyViewed(window.__currentProduct.id);
  } else {
    renderRecentlyViewed();
  }

  // Wishlist
  updateWishlistUI();
  document.querySelector('.js-wishlist-open')?.addEventListener('click', openWishlist);
  document.querySelector('.js-wishlist-close')?.addEventListener('click', closeWishlist);
  document.getElementById('WishlistScrim')?.addEventListener('click', closeWishlist);
  document.querySelectorAll('.js-wishlist-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      toggleWishlist({
        id: btn.dataset.id,
        handle: btn.dataset.handle,
        title: btn.dataset.title,
        price: btn.dataset.price,
        image: btn.dataset.image,
        url: btn.dataset.url
      });
      showToast(isWishlisted(btn.dataset.id) ? 'Added to wishlist' : 'Removed from wishlist');
    });
  });
  document.querySelector('.js-wishlist-items')?.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-wishlist-remove');
    if (btn) toggleWishlist({ id: btn.dataset.id });
  });

  // Predictive search
  document.querySelector('.js-search-open')?.addEventListener('click', openSearch);
  document.querySelector('.js-search-close')?.addEventListener('click', closeSearch);
  document.querySelector('.js-search-overlay')?.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-search-overlay')) closeSearch();
  });
  document.getElementById('SearchInput')?.addEventListener('input', (e) => {
    clearTimeout(searchDebounce);
    const term = e.target.value;
    searchDebounce = setTimeout(() => runSearch(term), 250);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeSearch(); closeWishlist(); closeSizeGuide(); closeFilterPanel(); }
  });

  // Quick add to cart (product cards)
  document.querySelectorAll('.js-quick-add').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (btn.disabled) return;
      addToCart(btn.dataset.variantId, 1);
    });
  });

  // Size guide modal
  document.querySelector('.js-size-guide-open')?.addEventListener('click', openSizeGuide);
  document.querySelector('.js-size-guide-close')?.addEventListener('click', closeSizeGuide);
  document.querySelector('.js-size-guide-overlay')?.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-size-guide-overlay')) closeSizeGuide();
  });

  // Mobile filter drawer (collection page)
  document.querySelector('.js-filter-open')?.addEventListener('click', openFilterPanel);
  document.querySelector('.js-filter-close')?.addEventListener('click', closeFilterPanel);
  document.getElementById('FilterScrim')?.addEventListener('click', closeFilterPanel);

  // Sticky mobile add-to-cart bar (product page)
  const stickyAtc = document.querySelector('.js-sticky-atc');
  const buyBox = document.querySelector('[data-product-form]');
  if (stickyAtc && buyBox) {
    const observer = new IntersectionObserver(([entry]) => {
      stickyAtc.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, { threshold: 0 });
    observer.observe(buyBox);
  }
  document.querySelector('.js-sticky-add-to-cart')?.addEventListener('click', () => {
    const id = document.getElementById('VariantId')?.value;
    const qtyVal = document.getElementById('qtyVal');
    const qty = qtyVal ? parseInt(qtyVal.textContent, 10) || 1 : 1;
    if (id) addToCart(id, qty);
  });

  // Accordion (product detail)
  document.querySelectorAll('.accordion__head').forEach(head => {
    head.addEventListener('click', () => head.parentElement.classList.toggle('open'));
  });

  // Product page: size selection -> resolve variant id
  const sizeRow = document.querySelector('.size-row');
  const variantInput = document.getElementById('VariantId');
  if (sizeRow && variantInput && window.__variants) {
    sizeRow.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        sizeRow.querySelectorAll('button').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const match = window.__variants.find(v =>
          [v.option1, v.option2, v.option3].includes(btn.dataset.value)
        );
        if (match) variantInput.value = match.id;
      });
    });
  }

  // Product page: gallery thumbs
  document.querySelectorAll('.pd-gallery__thumbs img').forEach(t => {
    t.addEventListener('click', () => {
      document.querySelectorAll('.pd-gallery__thumbs img').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      const main = document.getElementById('mainImg');
      if (main) main.src = t.dataset.full || t.src;
    });
  });

  // Product page: qty stepper
  let qty = 1;
  const qtyVal = document.getElementById('qtyVal');
  document.getElementById('qtyPlus')?.addEventListener('click', () => {
    qty++; if (qtyVal) qtyVal.textContent = qty;
  });
  document.getElementById('qtyMinus')?.addEventListener('click', () => {
    if (qty > 1) qty--; if (qtyVal) qtyVal.textContent = qty;
  });

  // Product page: add to cart form
  document.querySelector('[data-product-form]')?.addEventListener('submit', (e) => {
    e.preventDefault();
    const id = document.getElementById('VariantId')?.value;
    if (id) addToCart(id, qty);
  });

  // Product page: checkout now (buy-it-now)
  document.querySelector('.js-checkout-now')?.addEventListener('click', (e) => {
    const id = document.getElementById('VariantId')?.value;
    if (id) buyNow(id, qty, e.currentTarget);
  });
});
